<script lang="ts">
import { Label, RadioButtonSingle, Tooltip } from '@cf/ui-lib';
import { BrandStatusEnum, DomainsStatusEnum } from '@cf/ui-lib/typings';

export let status;
export let value: string;
export let onStatusChagne = (id: string, status: string) => {}

$: statusReactive = status
$: className = '';
$: {
		if (statusReactive.toLocaleLowerCase() === DomainsStatusEnum.Reported.toLocaleLowerCase()) {
		className = 'border-[#FFB900] bg-[#FFF8E6]';
	} else if (statusReactive.toLocaleLowerCase() === DomainsStatusEnum.Live.toLocaleLowerCase()) {
		className = 'border-[#F95353] bg-[#FEEEEE]';
	} else if (statusReactive.toLocaleLowerCase() ===  DomainsStatusEnum.Removed.toLocaleLowerCase()) {
		className = 'border-[#6C757D] bg-[#F0F1F2]';
	} else {
		className = 'border-[#6C757D] bg-[#F0F1F2]';
	}
}
export let id: string = '';

const  handleStatusChagne = (status: string) => {
	onStatusChagne(id, status);
	statusReactive = status
	value = status
}

</script>

<Tooltip id={id} idData="status" toggleClass="-mr-20" isCloseOnOutsideClick={true}>
	<ul class="grid list-none gap-[20px]" slot="tooltip-list">
		<li class="flex items-center gap-[10px]">
			<div class="flex">
				<RadioButtonSingle
					label={DomainsStatusEnum.Reported}
					name="status"
					value={value}
					on:change={(e) => handleStatusChagne(DomainsStatusEnum.Reported)}
					selectedOption={DomainsStatusEnum.Reported}
					lableClass="group border border-solid rounded px-3 py-2 w-[107px] text-xs font-semibold leading-[15px] font-inter text-dark text-center border-[#FFB900] bg-[#FFF8E6]"
				/>
			</div>
		</li>
		<li class="flex items-center gap-[10px]">
			<div class="flex">
				<RadioButtonSingle
					label={DomainsStatusEnum.Live}
					value={value}
					name="status"
					on:change={(e) => handleStatusChagne(DomainsStatusEnum.Live)}
					selectedOption={DomainsStatusEnum.Live}
					lableClass="group border border-solid rounded px-3 py-2 w-[107px] text-xs font-semibold leading-[15px] font-inter text-dark text-center border-[#F95353] bg-[#FEEEEE]"
				/>
			</div>
		</li>
		<li class="flex items-center gap-[10px]">
			<div class="flex">
				<RadioButtonSingle
					label={DomainsStatusEnum.Removed}
					name="status"
					value={value}
					on:change={(e) => handleStatusChagne(DomainsStatusEnum.Removed)}
					selectedOption={DomainsStatusEnum.Removed}
					lableClass="group border border-solid rounded px-3 py-2 w-[107px] text-xs font-semibold leading-[15px] font-inter text-dark text-center border-[#6C757D] bg-[#F0F1F2]"
				/>
			</div>
		</li>
	</ul>
	<div class="flex" slot="button-details">
		<div
			class="group w-[107px] rounded border border-solid px-3 py-2 text-center font-inter text-xs font-semibold leading-[15px] text-dark {className}"
		>
			{statusReactive}
		</div>
	</div>
</Tooltip>
